import data from "../../../../../src/CheckboxGroup/CheckboxGroup.docs.json";
import { CheckboxGroup, Checkbox, Box } from '@primer/components';
import { CheckIcon, XIcon, AlertIcon } from '@primer/octicons-react';
import DeprecationBanner from "../../../../components/DeprecationBanner";
import * as React from 'react';
export default {
  data,
  CheckboxGroup,
  Checkbox,
  Box,
  CheckIcon,
  XIcon,
  AlertIcon,
  DeprecationBanner,
  React
};